export const types = [ 'Story', 'Task', 'Bug' ];
export const priorities = [ 'Medium', 'Highest', 'High', 'Low', 'Lowest' ];
export const statuses = [ 'To do', 'Development', 'Testing', 'Done' ]; //[ 'اماده سازی', 'درحال کار', 'کنترل', 'اتمام رسیده' ];

export const initialStatuses = [
	{ title: 'ToDo', Issues: [] },
	{ title: 'Development', Issues: [] },
	{ title: 'Testing', Issues: [] },
	{ title: 'Done', Issues: [] }
];

export const initialIssue = {
	Title: '',
	Description: '',
	Type: 0,
	Priority: 0,
	Status: 0,
	StoryPoints: 0,
	SprintId: ''
};
